var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuyOrderPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5C4.14 15.5 1 12.36 1 8.5C1 4.64 4.14 1.5 8 1.5C11.86 1.5 15 4.64 15 8.5C15 12.36 11.86 15.5 8 15.5ZM8 2.5C4.69 2.5 2 5.19 2 8.5C2 11.81 4.69 14.5 8 14.5C11.31 14.5 14 11.81 14 8.5C14 5.19 11.31 2.5 8 2.5Z",
    fill: "#3BE8A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C7.72 12 7.5 11.78 7.5 11.5V5.5C7.5 5.22 7.72 5 8 5C8.28 5 8.5 5.22 8.5 5.5V11.5C8.5 11.78 8.28 12 8 12Z",
    fill: "#3BE8A2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9H5C4.72 9 4.5 8.78 4.5 8.5C4.5 8.22 4.72 8 5 8H11C11.28 8 11.5 8.22 11.5 8.5C11.5 8.78 11.28 9 11 9Z",
    fill: "#3BE8A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyOrderPlus);
export default __webpack_public_path__ + "static/media/buy-order-plus.a8a7fe513104cc0c0537146195bc3cbd.svg";
export { ForwardRef as ReactComponent };